<template>
	<Loader v-if="loading" />
	<div v-else>
		<div v-show="!addCard" class="credit-card-list">
			<div
				class="credit-card-list-item" 
				v-for="(card, id) in cards" 
				v-on:click="creditCard = card.id;" 
				v-bind:class="{
					selected: card.id == creditCard,
					clickable: select
				}"
				:key="'card'+id" >
					<CreditCard :selected="card.id == creditCard" :card="card" v-on:deleted="load()" />
			</div>
			<div class="credit-card-list-item" style="cursor: pointer;" v-on:click="openTerminal()">
				<span style="font-size: 20px; color: #999">+ {{ $t('checkout.add-card.label') }}</span>
				<!-- <button v-on:click="openTerminal()" class="purple">{{ $t('checkout.add-card.label') }}</button> -->
			</div>
		</div>

		<Terminal v-if="addCard" v-on:created="created()" />
	</div>
</template>

<script>
	import Vue from 'vue';
	import Terminal from './Terminal.vue';
	import CreditCard from './CreditCard.vue';
	import Loader from '../Loader.vue';
	export default {
		props: [
			'select',
			'value'
		],
		data: () => ({
			loading: false,
			creatingSession: false,
			scriptCreated: false,
			addCard: false,
			autoSelectNewest: false,
			cards: []
		}),
		computed: {
			creditCard: {
				get() {
					return this.value;
				},
				set(value) {
					this.$emit('input', value);
				}
			}
		},
		components: {
			Terminal,
			CreditCard,
			Loader
		},
		methods: {
			openTerminal() {
				this.$emit('terminalopened');
				this.addCard = true;
			},
			closeTerminal() {
				this.$emit('terminalclosed');
				this.addCard = false;
			},
			load() {
				Vue.api.get('/user/credit-cards', {}, {
					before: () => this.loading = true,
					always: () => this.loading = false,
					callback: data => this.parse(data)
				});
			},
			parse(data) {
				this.cards = data;
				if (data.length == 0) {
					this.openTerminal();
				}
				if (this.autoSelectNewest) {
					for (var i in this.cards) {
						this.creditCard = this.cards[i].id;
					}
					this.autoSelectNewest = false;
				}
			},
			created() {
				this.creditCard = false;
				this.autoSelectNewest = true;
				this.closeTerminal();
				this.load();
			}
		},
		created() {
			this.load();
		}
	}
</script>